import React from "react";
import styled from "styled-components";

interface IProps extends React.FormHTMLAttributes<HTMLElement> {
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}

const Form: React.FC<IProps> = ({ children, onSubmit, ...props }) => {
  return (
    <OutWrapper onSubmit={onSubmit} {...props}>
      {children}
    </OutWrapper>
  );
};

export default Form;

const OutWrapper = styled.form``;
